const actions = [
    {
        type: 'ADD',
        cards: []
    },
    {
        type: 'REMOVE',
        storeId: 1
    },
    {
        type: 'UPDATE',
        cards: []
    },
    {
        type: 'REMOVE_ALL'
    }
];

export default actions;



/** WEBPACK FOOTER **
 ** ./src/actions/eshopActions.js
 **/